export default __webpack_public_path__ + "static/media/AllProductItems5.69b75d7f.png";